import {
    BACKEND,
    apiEndpoint,
} from '../utils/api';

export const backendEndpoint = apiEndpoint({
    api: BACKEND,
    endpoint: 'job/custom-fields',
});

export async function getCustomFields(jobId) {
    return backendEndpoint.get('', { params: { jobId } });
}
